(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("@material/segmented-button", [], factory);
	else if(typeof exports === 'object')
		exports["segmented-button"] = factory();
	else
		root["mdc"] = root["mdc"] || {}, root["mdc"]["segmented-button"] = factory();
})(this, function() {
return 